import { HttpBackend, HttpClient, HttpContextToken, HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, tap, throwError } from 'rxjs';

// Services
import { AppConfigService } from '@core/services/app-config.service';

const CSRF_RETRIED = new HttpContextToken<boolean>(() => false);

export const csrfInterceptor: HttpInterceptorFn = (req, next) => {
	const appConfig = inject(AppConfigService);
	const rawHttp = new HttpClient(inject(HttpBackend));
	
	const withCsrf = (r: HttpRequest<unknown>) => {
		if (!['POST', 'PUT', 'DELETE', 'PATCH'].includes(r.method)) return r;
		const headers: Record<string, string> = { [appConfig.csrfHeaderName]: appConfig.csrfToken };
		if (!r.headers.has('Content-Type') && !(r.body instanceof FormData)) {
			headers['Content-Type'] = 'application/json;charset=UTF-8';
		}
		return r.clone({ setHeaders: headers });
	};

	return next(withCsrf(req)).pipe(
		catchError((err) => {
			if (!(err instanceof HttpErrorResponse) || err.status !== 403 || req.context.get(CSRF_RETRIED)) {
				return throwError(() => err);
			}
			return rawHttp.get<{ token: string }>('public/csrf').pipe(
				tap((res) => (window.appConfig.csrf.token = res.token)),
				switchMap(() => next(withCsrf(req.clone({ context: req.context.set(CSRF_RETRIED, true) })))),
			);
		}),
	);
};
